/* MAIN */
const noop = () => { };
/* EXPORT */
export { noop };
